export default __webpack_public_path__ + "images/title_background.7a44a1903fdabb6dff411e0c8f477dc3.png";